import { addIntegration } from '@sentry/nuxt'

export default defineNuxtPlugin({
  name: 'sentry',
  parallel: true,
  setup: () => {
    onNuxtReady(() => {
      const router = useRouter()
      import('@sentry/browser').then((lazyLoadedSentry) => {
        addIntegration(lazyLoadedSentry.replayIntegration())
        addIntegration(lazyLoadedSentry.browserTracingIntegration({ router }))
        addIntegration(
          lazyLoadedSentry.captureConsoleIntegration({
            levels: ['error'],
          })
        )
        addIntegration(lazyLoadedSentry.httpClientIntegration())
      })
    })
  },
})
